import React from 'react';
import { IconButton, Tooltip, useTheme as useMuiTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
    const { mode, toggleColorMode } = useTheme();
    const muiTheme = useMuiTheme();

    return (
        <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
            <IconButton
                onClick={toggleColorMode}
                color="inherit"
                aria-label="toggle theme"
                edge="end"
                size="large"
                sx={{ ml: 1 }}
            >
                {mode === 'light' ? (
                    <Brightness4Icon />
                ) : (
                    <Brightness7Icon sx={{ color: muiTheme.palette.primary.main }} />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle; 